module.exports = ".btns {\r\n    background-color: #d9534f;\r\n    border-color: #d43f3a;\r\n    color: #fff;\r\n    padding: 7px 18px 8px;\r\n}\r\n\r\n/* option:hover {\r\n    background-colour : #000000;\r\n    color : #ffffff;\r\n    }\r\n    {\r\n   \r\n} */\r\n\r\nselect:hover {\r\n    color: #444645;\r\n    background-color: rgb(231, 17, 17);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/layout/components/header/header.component.css
// module id = ./src/app/containers/layout/components/header/header.component.css
// module chunks = main